var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:[
    _vm.background,
    _vm.gradient,
    _vm.outline,
    _vm.rounded,
    _vm.size,
    _vm.block,
    {
      'btn-medium': _vm.btnMedium,
      'btn-center': _vm.btnCenter,
      'btn-left': _vm.btnLeft,
      'btn-right': _vm.btnRight,
    },
  ],attrs:{"type":_vm.typeBtn,"active":_vm.active,"disabled":_vm.disabledBtn}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }